import { roundToPlaces } from "../../utils/roundToPlaces.js";
import type { OrderProduct } from "../OrderProduct.js";
import { TaxLevel } from "../TaxLevel.js";
import { calculatePriceWithoutTax } from "./calculatePriceWithoutTax.js";

export function getPriceOfOrderProduct({ price, quantity }: Pick<OrderProduct, "price" | "quantity">): {
	withTax: number;
	withoutTax: number;
	unitWithTax: number;
	unitWithoutTax: number;
} {
	const unitPriceWithTax = price;
	const totalWithTax = unitPriceWithTax * quantity;
	return {
		withTax: roundToPlaces(totalWithTax, 2),
		withoutTax: calculatePriceWithoutTax(totalWithTax, TaxLevel.TaxLevel21),
		unitWithTax: roundToPlaces(unitPriceWithTax, 2),
		unitWithoutTax: calculatePriceWithoutTax(unitPriceWithTax, TaxLevel.TaxLevel21),
	};
}
